module.exports = __webpack_public_path__ + "img/theme-index-red.c8e136e1.png";